
/**
 * Type of tweet
 */
export type TweetType = typeof TweetType[keyof typeof TweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
